import { Component } from 'react';
import ErrorPage from './ErrorPage';
import { setRobots } from '../hooks/usePageMeta';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    document.title = 'Something Went Wrong (500) | Printable Graph Paper';
    setRobots('noindex, follow');
    if (typeof this.props.onError === 'function') {
      this.props.onError(error, info);
    }
  }

  handleReset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      return <ErrorPage code={500} onReset={this.handleReset} />;
    }

    return this.props.children;
  }
}
